export default __webpack_public_path__ + "static/media/meeting-icon.4dc4cb2a.svg";